import * as apiGet from 'api/menuPlanner/GetMenuPlannerIdV1';
import * as apiPostCalculate from 'api/menuPlanner/PostMenuPlannerCalculateV1';
import * as apiPut from 'api/menuPlanner/PutMenuPlannerIdV1';
import AllergenList from 'classes/MenuPlan/Detail/AllergenList';
import ImageList from 'classes/MenuPlan/Detail/ImageList';
import TagList from 'classes/MenuPlan/Detail/TagList';
import { MENUPLANNERITEMTYPE } from 'enums/MENUPLANNERITEMTYPE';
import { LocalizedTranslation } from 'types/_general/LocalizedTranslation';

export default class Item {
	public id: string = '';
	public type: MENUPLANNERITEMTYPE = MENUPLANNERITEMTYPE.MENU;
	public day: number = 0;
	public images: ImageList = new ImageList();
	public title: LocalizedTranslation<string> | null = null;
	public pinned: boolean = false;
	public quantity: number = 0;
	public price: number = 0;
	public calories: number = 0;
	public tags: TagList = new TagList();
	public allergens: AllergenList = new AllergenList();
	public children: apiGet.ChildrenItem[] = [];

	public constructor(input?: apiGet.Item) {
		if (!input) return;
		this.mapFromApi(input);
	}

	public mapFromApi(input: apiGet.Item): void {
		this.id = input.id;
		this.type = input.type;
		this.day = input.day;
		this.images.mapFromApi(input.images);
		this.title = input.titleTranslations;
		this.pinned = false;
		this.price = input.price;
		this.calories = input.calories;
		this.tags.mapFromApi(input.tags);
		this.allergens.mapFromApi(input.allergens);
		this.quantity = input.quantity < 0 ? 0 : input.quantity;
		this.children = input.children;
	}

	public mapToApi(): apiPut.Item {
		return {
			id: this.id,
			type: this.type,
			day: this.day,
			quantity: this.quantity,
		};
	}

	public mapToApiCalculate(total: boolean): apiPostCalculate.Row[] {
		if (!total) return [{ id: this.id, type: this.type }];
		const output: apiPostCalculate.Row[] = [];
		for (let i = 0; i < this.quantity; i++) {
			output.push({
				id: this.id,
				type: this.type,
			});
		}
		return output;
	}
}
